import { Drawer } from 'components/Drawer'
import { BrandKitColorSelector } from 'components/BrandKitForm/BrandKitColorSelector/BrandKitColorSelector'
import { Button } from 'blaze-ui/Button'
import { DrawerProps } from 'components/Drawer/Root'
import Styles from './BrandKitColors.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { useMemo } from 'react'
import { useRootStore } from 'stores/RootStore'
import { observer } from 'mobx-react-lite'

interface Props extends DrawerProps {
  palettes: string[][]
  selectedPaletteIndex: number
  websitePaletteIndex: number
  onPaletteSelect: (palette: string[], index: number) => void
  onConfirm: () => void
}

export const ColorsDrawer = observer(
  ({ palettes, selectedPaletteIndex, websitePaletteIndex, onPaletteSelect, onConfirm, ...props }: Props) => {
    const { drawersStore } = useRootStore()
    const originalColorPalette = useMemo(() => selectedPaletteIndex, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
      <Drawer.Root {...props}>
        <Drawer.Portal>
          <Drawer.Content>
            <Drawer.InnerContent>
              <Drawer.Top>
                <Drawer.Back
                  variant="ghost"
                  position="left"
                  onPress={() => {
                    onPaletteSelect(palettes[originalColorPalette], originalColorPalette)
                    drawersStore.closeDrawer()
                  }}
                />
                <Drawer.Title asChild>
                  <Heading level={5}>Pick your Colors</Heading>
                </Drawer.Title>
                <Drawer.Action variant="ghost" position="right" onPress={onConfirm}>
                  Save
                </Drawer.Action>
              </Drawer.Top>
              <Drawer.Container padding="5px 15px 15px 15px">
                <div className={Styles.drawerContent}>
                  <BrandKitColorSelector
                    palettes={palettes}
                    selectedPaletteIndex={selectedPaletteIndex}
                    websitePaletteIndex={websitePaletteIndex}
                    onPaletteSelect={onPaletteSelect}
                    showTitle={false}
                  />
                  <Button size="lg" fullWidth onPress={onConfirm}>
                    Save Color
                  </Button>
                </div>
              </Drawer.Container>
            </Drawer.InnerContent>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    )
  },
)
